
import {on} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";

export function init () {
    onFind('.js-ajax-form', function ($element) {
        on('fetch.ajax-form', function () {
            scrollTop($element);
        }, $element);
    });
}

export function scrollTop($element) {
    let navOffset = matchMedia('(max-width: 767px)').matches ? 150 : 200;
    let offset = $element.getBoundingClientRect().top + window.pageYOffset - navOffset;
    try {
        window.scroll({
            top: offset,
            behavior: 'smooth'
        });
    } catch (e) {
        window.scrollTo(0, offset)
    }
}

